import React, { useContext, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import api from 'api';
import useSearchParams from 'hooks/useSearchParams';
import { useTranslation } from 'react-i18next';
import useQueryParams from 'hooks/useQueryParams';
import ResolvePagination from 'components/ResolvePagination';
import WatchlistPortfolioCard from './components/WatchlistPortfolioCard';
import { PortfoilioLead } from 'api/portfolio/buyer';
import PortfolioDefaulEmpty from 'components/PortfolioDefaulEmpty';
import BackLink from 'components/BackLink';
import PortfolioPlaceholderCards from '../../components/PortfolioPlaceholderCards';
import { SIZE } from 'models/Size';
import { PF_GRID_VIEW_LIMIT } from '../../../data';

import './Watchlist.styles.scss';
import './Watchlist.styles.responsive.scss';

type WatchlistProps = {
  className?: string;
};

const Watchlist: React.FC<WatchlistProps> = (props) => {
  const { className } = props;
  const { popServerError } = useContext(PopNotificationsContext);
  const { t } = useTranslation();
  const { params } = useQueryParams();
  const { page = 1 } = params;
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [deals, setDeals] = useState<PortfoilioLead[]>([]);

  const classes = classNames('watchlist', className);

  const searchParams = useSearchParams();

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const {
          data: { totalPages, items },
        } = await api.portfolio.buyer.getWatchlistedListings({
          $page: `${page}`,
          $limit: `${PF_GRID_VIEW_LIMIT}`,
          $relations: '["listing","buyer","listingEnquiry","dealRoom"]',
          ...searchParams,
        });

        setTotalPages(totalPages);
        setDeals(items);
      } catch (e) {
        popServerError(e);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [page, popServerError, searchParams]);

  const renderDeals = useMemo(
    () =>
      isLoading ? (
        <PortfolioPlaceholderCards
          numberOfCards={PF_GRID_VIEW_LIMIT}
          size={SIZE.SMALL}
        />
      ) : (
        deals.map(
          ({
            dealRoom: {
              _id,
              stage,
              listingStage,
              createdAt,
              industry,
              dealOutcome,
              otherDealOutcome,
              portfolioName,
              isColleague,
              userId,
              user,
            },
            listing: {
              gallery,
              type,
              expirationDate,
              seekingExpressionOfInterestDate,
              slugName,
            },
          }) => (
            <WatchlistPortfolioCard
              key={_id}
              dealStage={stage}
              listingStage={listingStage}
              imageSrc={gallery[0]?.url}
              title={portfolioName}
              date={createdAt}
              isColleague={isColleague}
              dealOutcome={dealOutcome}
              otherDealOutcome={otherDealOutcome}
              listingType={type}
              industry={industry}
              seekingExpressionOfInterestDate={seekingExpressionOfInterestDate}
              expirationDate={expirationDate}
              ownerId={userId}
              owner={user}
              slugName={slugName}
            />
          ),
        )
      ),
    [deals, isLoading],
  );

  return (
    <div className={classes}>
      <BackLink>{t('portfolio')}</BackLink>

      <p className="title">{t('shortlist')}</p>

      <div className="resolve-page-items">
        {deals.length || isLoading ? renderDeals : <PortfolioDefaulEmpty />}
      </div>
      <ResolvePagination totalPages={totalPages} />
    </div>
  );
};

export default Watchlist;
